<sco-header
  #headerRef
  style="position: fixed; top: 0; left: 0; width: 100%; background-color: #fff; z-index: 70"
  [withSearch]="true"
  [searchPlaceholder]="'SEARCH_PLACEHOLDER' | translate"
  [searchTerm]="searchString && searchString.trim() ? searchString : ''"
  [searchContextChipTitle]="searchContentTitle !== null ? searchContentTitle : ''"
  [searchTrailingButton]="true"
  [showSearchLeadingIcon]="false"
  (searchEntered)="searchEntered()"
  (searchInputChanged)="searchInputChanged($event)"
  (clearSearchContext)="clearSearchContext()"
  (clearSearchInput)="clearSearchInput()"
  [searchShowDropdown]="
    (hasActivityData ||
      searchSuggestions.length > 0 ||
      (isLoadingSuggestions && !!searchString.trim()) ||
      (!isLoadingSuggestions && !!searchString.trim() && searchSuggestions.length === 0)) &&
    loggedIn
  "
  [searchOpenDropdownOn]="'focus'">
  <ng-template #logo>
    <a [routerLink]="'/' | localize">
      <img [src]="'./assets/' + client + '-logo.svg'" style="min-width: 6.25rem" />
    </a>
  </ng-template>
  <ng-template #mainRightContent>
    <!-- Language menu -->
    <div class="flex flex-wrap items-center ml-auto gap-0 lg:gap-[var(--sco-spacing-24)]">
      <div class="desktop-menu self-stretch">
        <sco-dropdown
          [menuItems]="languageMenuItems"
          [title]="!isTabletOrMobile ? ('LANGUAGES.' + activeLang | translate) : ''"
          iconLeft="bi bi-globe-americas"
          (menuButtonClicked)="onLanguageMenuClick($event)">
        </sco-dropdown>
      </div>

      @if (loggedIn) {
        <ng-container *schuecoFeatureFlagActive="'news-bell'">
          @if (!isTabletOrMobile) {
            <div style="width: 1px; height: 24px; background: var(--sco-outline-variant)"></div>
          }
          <button
            scoIconButton
            [size]="'medium'"
            [variant]="'trailing'"
            [icon]="'bi bi-bell'"
            [isDisabled]="!isCategoryTreeLoaded"
            [isSelected]="false"
            [isHovered]="false"
            [withBackground]="false"
            [withBadge]="showNewsBadge"
            [badgeSize]="'small'"
            (click)="openNewsDialog()"></button>
        </ng-container>
      }
      <!-- Profile menu -->
      <div class="desktop-menu">
        <div class="avatar-wrapper">
          <sco-dropdown
            [menuItems]="profileMenuItems"
            initials="{{ (userGivenName?.charAt(0) || '') + (userFamilyName?.charAt(0) || '') || 'bi bi-person' }}"
            (menuButtonClicked)="onProfileMenuClick($event)">
          </sco-dropdown>
          @if (isCustomViewActive) {
            <span class="status-indicator"></span>
          }
        </div>
      </div>

      <!-- Burger menu -->
      <div class="ml-[var(--sco-spacing-32)] mobile-menu">
        <div class="avatar-wrapper">
          <sco-dropdown
            [menuItems]="mobileMenuItems"
            initials="{{ (userGivenName?.charAt(0) || '') + (userFamilyName?.charAt(0) || '') || 'bi bi-person' }}"
            (menuButtonClicked)="onMobileMenuClick($event)">
          </sco-dropdown>
          @if (isCustomViewActive) {
            <span class="status-indicator"></span>
          }
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #mainMenu>
    <div class="flex flex-wrap justify-between w-full h-full">
      <!-- Main menu left -->
      <div class="flex flex-wrap gap-[var(--sco-spacing-12)]">
        <div class="content-center hidden sm:flex mr-8 pt-[2px]">
          <button
            scoIconButton
            size="small"
            variant="trailing"
            icon="bi bi-arrow-left"
            class="pt-[2px]"
            [isDisabled]="!canGoBack()"
            [scoTooltip]="'BACK' | translate"
            (click)="goBack()">
          </button>
        </div>

        <!-- TODO: move disabled state to Styleguide? -->
        <sco-dropdown-navigation
          [ngStyle]="{
            pointerEvents: hasNavigationLinks ? 'auto' : 'none',
            opacity: hasNavigationLinks ? 1 : 0.38,
          }"
          class="sco-dropdown-navigation-1"
          style="height: 100%"
          [navigation]="navigation"
          [targetItemId]="navigationTargetItemId"
          parentItemText="{{ 'SHOW_ALL' | translate }}"
          [isTouchDisplay]="isTouchDisplay"
          [isMobileView]="true"
          [listMaxHeight]="'calc(100vh - 120px)'"
          (selectedItemLink)="selectedNavigationItemLink($event)">
        </sco-dropdown-navigation>

        @if (client !== 'aks') {
          <sco-dropdown
            [menuItems]="loggedIn ? weblinksMenuItems : []"
            title="{{ 'LINKS' | translate }}"
            [ngClass]="{ 'dropdown-disabled': !loggedIn || weblinksMenuItems.length === 0 }"
            class="sco-dropdown-1">
          </sco-dropdown>
        }

        <button
          scoButton
          [variant]="'link'"
          [size]="'small'"
          [onlyIcon]="isMobile"
          [disabled]="!loggedIn"
          class="global-scss-button"
          (click)="openFavorites()">
          <i style="font-size: 0.75rem" class="pr-[2px] pt-[2px] bi bi-star"></i>
          @if (!isMobile) {
            <span class="hidden sm:inline">
              {{ 'FAVORITES' | translate }}
            </span>
          }
        </button>
      </div>

      <!-- Main menu right -->
      <div class="content-center relative flex items-center gap-[var(--sco-spacing-8)]">
        @if (client === 'schueco' && loggedIn && standardCountryId !== null && standardCountryId !== 'FR') {
          <button
            scoButton
            variant="link"
            [size]="isMobile ? 'medium' : 'small'"
            [onlyIcon]="isMobile"
            (click)="openExternalLink()">
            @if (!isDownloadListActive) {
              <i class="bi bi-card-text"></i>
            }
            @if (!isMobile) {
              <span class="hidden sm:inline">
                {{ 'EXTERNAL_LINKS.SPECIFICATION_TEXTS' | translate }}
              </span>
            }
          </button>
        }
        @if (client === 'aks') {
          <button
            scoButton
            variant="link"
            [size]="isMobile ? 'medium' : 'small'"
            [onlyIcon]="isMobile"
            (click)="openExternalLink()">
            <svg width="24" height="24" viewBox="0 -1 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.82875 8.28027C2.08785 8.18702 2.37515 8.32125 2.46938 8.58008C2.5631 8.83924 2.4284 9.12625 2.16957 9.2207C1.33773 9.52241 1.10484 9.79302 1.05434 9.90625C1.03456 9.95145 1.01746 10.0358 1.17836 10.209C1.28528 10.3237 1.52975 10.4935 1.95571 10.6816C2.37063 10.8648 2.92091 11.0496 3.59828 11.2139C4.95273 11.5422 6.79039 11.7832 9.02309 11.7832C9.4525 11.7832 9.8629 11.7741 10.2536 11.7617L9.70668 11.3975C9.47435 11.2426 9.41699 10.9392 9.57875 10.7197C9.74082 10.5002 10.0611 10.4476 10.2936 10.6025L11.7936 11.6016C11.8003 11.606 11.8057 11.6125 11.8122 11.6172C11.8326 11.6321 11.8523 11.6468 11.8698 11.6641C11.8731 11.6673 11.8754 11.6715 11.8786 11.6748C11.8983 11.6954 11.9168 11.7162 11.9323 11.7393C11.9341 11.742 11.9353 11.7452 11.9372 11.748C11.9688 11.7975 11.991 11.851 12.0026 11.9072C12.0053 11.9201 12.0059 11.9332 12.0075 11.9463C12.0095 11.9636 12.0123 11.9806 12.0123 11.998C12.0125 12.0151 12.0101 12.0318 12.0084 12.0488C12.0072 12.0609 12.0068 12.073 12.0045 12.085C12.0001 12.1096 11.9916 12.1332 11.983 12.1572C11.9809 12.163 11.9795 12.169 11.9772 12.1748C11.9673 12.1995 11.9546 12.2227 11.9401 12.2461C11.9375 12.2502 11.9369 12.2557 11.9342 12.2598L11.9274 12.2686C11.9249 12.2721 11.9241 12.2768 11.9215 12.2803L11.9176 12.2832L10.9342 13.7588C10.7829 13.9857 10.4658 14.0542 10.2262 13.9111C9.987 13.7678 9.9153 13.4681 10.0661 13.2412L10.3864 12.7598C9.95445 12.7746 9.4995 12.7832 9.02309 12.7832C6.72184 12.7832 4.80437 12.535 3.36293 12.1855C2.64286 12.0109 2.03319 11.8094 1.55141 11.5967C1.08166 11.3892 0.690558 11.1526 0.44594 10.8896C0.165742 10.5881 -0.115813 10.0824 0.1393 9.50293C0.365323 8.99122 0.949781 8.59907 1.82875 8.28027Z"
                fill="#353535" />
              <path
                d="M15.5016 8.54688C15.6144 8.29551 15.91 8.18183 16.1618 8.29395C16.5531 8.46873 16.8973 8.65471 17.1745 8.85254C17.4465 9.04686 17.6864 9.27606 17.8307 9.54785C17.985 9.83915 18.0211 10.1693 17.8932 10.4961C17.7742 10.7989 17.5339 11.0483 17.2457 11.2559C16.544 11.7607 15.3205 12.215 13.4674 12.4941C13.3161 12.5169 13.16 12.5382 12.9997 12.5586V11.5498C13.1081 11.5352 13.2144 11.5205 13.318 11.5049C15.1062 11.2355 16.1477 10.8141 16.6618 10.4443C16.8693 10.2948 16.9414 10.1843 16.9625 10.1309C16.9737 10.1022 16.9789 10.0755 16.9479 10.0166C16.9054 9.93684 16.8024 9.81531 16.5934 9.66602C16.3886 9.51985 16.1091 9.3654 15.7545 9.20703C15.5027 9.09444 15.3894 8.79883 15.5016 8.54688Z"
                fill="#353535" />
              <path
                d="M4.81996 5C5.57651 5.00007 6.50258 5.34948 6.50258 6.36133C6.50242 7.00318 6.08459 7.43552 5.4977 7.5332C6.13677 7.63787 6.60006 8.0218 6.60024 8.78223C6.60024 9.9057 5.6157 10.2616 4.7809 10.2617C3.85473 10.2617 3.06487 9.90627 2.99965 8.76172H3.97817C3.99121 9.27816 4.34359 9.53613 4.77407 9.53613C5.23054 9.53613 5.62157 9.25733 5.62172 8.69922C5.62172 8.06426 5.08084 7.90339 4.61782 7.90332C4.51346 7.90332 4.40186 7.91685 4.2975 7.92383V7.21973C4.38229 7.22671 4.46759 7.2334 4.55239 7.2334C5.01534 7.23338 5.54333 7.0868 5.5436 6.45215C5.5436 5.97769 5.18515 5.71887 4.80043 5.71875C4.5004 5.71875 4.08949 5.89343 4.08949 6.42383C4.08949 6.42383 3.09113 6.42383 3.08461 6.42383C3.08461 5.41188 4.06337 5 4.81996 5Z"
                fill="#353535" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.26723 5C10.0956 5 10.7936 5.40521 10.7936 6.36133H9.85414C9.85414 5.8938 9.60669 5.68365 9.235 5.68359C8.4458 5.68359 8.31477 6.83573 8.30824 7.5127C8.57566 7.01021 8.96778 6.80762 9.48305 6.80762C10.3047 6.8078 10.944 7.45011 10.944 8.46191C10.9438 9.55038 10.1871 10.2616 9.235 10.2617C7.83922 10.2617 7.3893 9.04757 7.3893 7.67969C7.38935 6.31197 7.85214 5.00014 9.26723 5ZM9.25453 7.49121C8.64143 7.49121 8.41274 7.97307 8.41274 8.52441C8.41275 9.08272 8.71322 9.5293 9.235 9.5293C9.76959 9.52921 10.0366 9.06894 10.0368 8.50391C10.0368 7.94563 9.78929 7.49128 9.25453 7.49121Z"
                fill="#353535" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.3893 5C14.7654 5.0001 15.1764 6.29152 15.1764 7.60352C15.1763 8.9433 14.7588 10.2616 13.3698 10.2617C11.987 10.2617 11.5885 8.90775 11.5885 7.5957C11.5886 6.2908 12.0328 5 13.3893 5ZM13.402 5.72559C12.5805 5.72579 12.5739 7.03759 12.5739 7.67969C12.5739 8.27988 12.6067 9.5293 13.3698 9.5293C14.1522 9.5291 14.1979 8.29409 14.1979 7.66602C14.1979 7.03791 14.1847 5.72559 13.402 5.72559Z"
                fill="#353535" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.9176 5.04199C17.524 5.04218 17.9997 5.53077 17.9997 6.17969C17.9995 6.82845 17.5239 7.31719 16.9176 7.31738C16.3111 7.31738 15.8348 6.82857 15.8346 6.17969C15.8346 5.53064 16.311 5.04199 16.9176 5.04199ZM16.9176 5.60059C16.6241 5.60059 16.4088 5.8447 16.4088 6.17969C16.409 6.51451 16.6242 6.75879 16.9176 6.75879C17.2174 6.7586 17.4263 6.51438 17.4264 6.17969C17.4264 5.84483 17.2175 5.60078 16.9176 5.60059Z"
                fill="#353535" />
            </svg>
            <span class="hidden sm:inline">
              {{ 'EXTERNAL_LINKS.VIRTUAL_SHOWROOM' | translate }}
            </span>
          </button>
        }
        @if (
          (client === 'schueco' && loggedIn && standardCountryId !== null && standardCountryId !== 'FR') ||
          client === 'aks'
        ) {
          <div style="width: 1px; height: 24px; background: #ccc; margin: 0 15px 0 0"></div>
        }
        <button
          scoButton
          variant="outline"
          [size]="isMobile ? 'medium' : 'small'"
          [onlyIcon]="isMobile"
          (click)="subscribeAndOpenDownloadDialog()">
          @if (!isDownloadListActive) {
            <i class="bi bi-clipboard-plus"></i>
          }
          @if (isDownloadListActive) {
            <sco-loading-indicator size="small"></sco-loading-indicator>
          }
          @if (!isMobile) {
            <span class="hidden sm:inline">
              {{ 'DOWNLOAD_LIST' | translate }}
            </span>
          }
          <!-- Badge -->
          @if (downloadListCount > 0) {
            <span class="badge-count">
              {{ downloadListCount }}
            </span>
          }
        </button>
      </div>
    </div>
  </ng-template>
  <ng-template #searchDropdownContent>
    <div class="dropdown-content">
      <!-- Search Suggestions (Skeleton während Ladevorgang) -->
      @if (isLoadingSuggestions && searchString.trim()) {
        <div class="dropdown-section">
          <div class="dropdown-items dropdown-items--scrollable">
            @for (i of [0, 1, 2, 3]; track i) {
              <div class="dropdown-item" [style.margin-top]="i === 0 ? '0.375rem' : null">
                <div class="skeleton skeleton-image"></div>
                <div class="document-info flex flex-col gap-2">
                  <div class="skeleton skeleton-title"></div>
                  <div class="skeleton skeleton-chip"></div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- Keine Suchergebnisse -->
      @if (!isLoadingSuggestions && !!searchString.trim() && searchSuggestions.length === 0) {
        <div class="dropdown-section">
          <div class="dropdown-items">
            <div class="dropdown-item dropdown-item--no-results">
              <div class="item-title sco-body-medium-regular">{{ 'SEARCH_NO_RESULTS' | translate }}</div>
            </div>
          </div>
        </div>
      }

      <!-- Search Suggestions -->
      @if (!isLoadingSuggestions && searchSuggestions.length > 0) {
        <div class="dropdown-section">
          <div class="dropdown-items dropdown-items--scrollable">
            @for (result of searchSuggestions; track result; let i = $index) {
              <div
                class="dropdown-item"
                [class.dropdown-item--active]="activeDropdownIndex === getGlobalDropdownIndex('suggestion', i)"
                [style.margin-top]="i === 0 ? '0.375rem' : null"
                (click)="onSuggestionClick(result); headerRef.closeSearchDropdown()">
                <img
                  [src]="result.base.cover || 'assets/img/thumbnail-placeholder.png'"
                  (error)="$any($event.target).src = 'assets/img/thumbnail-placeholder.png'"
                  [alt]="result.base.name"
                  class="document-cover-image" />
                <div class="document-info flex flex-wrap justify-between items-center gap-2">
                  <div class="flex-1 min-w-0" style="min-width: 7rem">
                    <div class="item-title sco-body-medium-medium line-clamp-2" style="margin-bottom: 4px">{{
                      result.base.name
                    }}</div>
                    <div
                      [style.max-width]="isTabletOrMobile ? '120px' : 'none'"
                      style="
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      ">
                      <sco-standard-chip label="{{ result.base.document_type }}"></sco-standard-chip>
                    </div>
                  </div>
                  @if (result.tags && result.tags.length > 0) {
                    <div class="document-tags !ml-0">
                      @for (tag of result.tags; track tag) {
                        <sco-display-chip
                          [label]="tag.name"
                          [icon]="tag.icon_name ? tag.icon_name : undefined"
                          [backgroundColor]="
                            tag.background_color ? 'rgba(' + tag.background_color.join(',') + ')' : undefined
                          "
                          [textColor]="tag.text_color ? 'rgba(' + tag.text_color.join(',') + ')' : undefined"
                          [signal]="!!tag.background_color && !!tag.text_color">
                        </sco-display-chip>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- Letzte Suchbegriffe -->
      @if (!searchString.trim() && recentSearchTerms && recentSearchTerms.length > 0) {
        <div class="dropdown-section dropdown-section--fixed">
          <div class="dropdown-section-title">
            {{ 'LAST_SEARCHED' | translate }}
          </div>
          <div class="dropdown-items">
            @for (term of recentSearchTerms; track term; let i = $index; let last = $last) {
              <div
                class="dropdown-item"
                [class.dropdown-item--active]="activeDropdownIndex === getGlobalDropdownIndex('recent', i)"
                [style.margin-bottom]="last ? '8px' : null"
                (click)="onRecentSearchClick(term); headerRef.closeSearchDropdown()">
                <i class="bi bi-clock-history"></i>
                <div class="item-title sco-body-medium-regular">{{ term }}</div>
              </div>
            }
          </div>
        </div>
      }

      <!-- Zuletzt angesehene Dokumente -->
      @if (!searchString.trim() && lastViewedDocuments && lastViewedDocuments.length > 0) {
        <div class="dropdown-section">
          <div class="dropdown-section-title" style="border-top: 1px solid var(--sco-outline-variant); margin-top: 5px">
            {{ 'RECENTLY_VIEWED_ITEMS' | translate }}
          </div>
          <div class="dropdown-items dropdown-items--scrollable">
            @for (doc of lastViewedDocuments; track doc; let i = $index) {
              <div
                class="dropdown-item"
                [class.dropdown-item--active]="activeDropdownIndex === getGlobalDropdownIndex('document', i)"
                (click)="onDocumentClick(doc); headerRef.closeSearchDropdown()">
                <img
                  [src]="doc.cover_image || 'assets/img/thumbnail-placeholder.png'"
                  (error)="$any($event.target).src = 'assets/img/thumbnail-placeholder.png'"
                  [alt]="doc.title"
                  class="document-cover-image" />
                <div class="document-info flex flex-wrap justify-between items-center gap-2">
                  <div class="flex-1 min-w-0" style="min-width: 7rem">
                    <div class="item-title sco-body-medium-medium line-clamp-2" style="margin-bottom: 4px">{{
                      doc.title
                    }}</div>
                    <div
                      [style.max-width]="isTabletOrMobile ? '120px' : 'none'"
                      style="
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      ">
                      <sco-standard-chip label="{{ doc.document_type }}"></sco-standard-chip>
                    </div>
                  </div>
                  @if (doc.tags && doc.tags.length > 0) {
                    <div class="document-tags !ml-0">
                      @for (tag of doc.tags; track tag) {
                        <sco-display-chip
                          [label]="tag.name"
                          [icon]="tag.icon_name ? tag.icon_name : undefined"
                          [backgroundColor]="
                            tag.background_color ? 'rgba(' + tag.background_color.join(',') + ')' : undefined
                          "
                          [textColor]="tag.text_color ? 'rgba(' + tag.text_color.join(',') + ')' : undefined"
                          [signal]="!!tag.background_color && !!tag.text_color">
                        </sco-display-chip>
                      }
                    </div>
                  }
                </div>
                <button
                  scoButton
                  variant="link"
                  [onlyIcon]="true"
                  class="document-remove-btn"
                  (click)="removeLastViewedDocument(doc, $event)">
                  <i class="bi bi-x"></i>
                </button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </ng-template>
</sco-header>

@if (!loggedIn) {
  <div class="text-center w-full">
    <div class="p-2" style="background-color: var(--sco-attention-container)">
      <span class="sco-body-medium-regular text-[var(--sco-grey-800)]">
        {{ 'LOGIN_NOTIFICATION.TEXT' | translate }}
        <a class="underline cursor-pointer" (click)="login()">{{ 'LOGIN_NOTIFICATION.TO_LOGIN' | translate }}</a>
        {{ 'LOGIN_NOTIFICATION.END_TEXT' | translate }}
      </span>
    </div>
  </div>
}

@if (isOffline) {
  <div class="text-center w-full">
    <div class="p-2" style="background-color: var(--sco-attention-container)">
      <span class="sco-body-medium-regular text-[var(--sco-grey-800)]">
        {{ 'OFFLINE_NOTIFICATION' | translate }}
      </span>
    </div>
  </div>
}
